module.exports = __webpack_public_path__ + "static/img/BEN-RONGDIT.0c2d150.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/BEN-RONGDIT.jpg
// module id = 51be
// module chunks = 0